import logo from "../assets/img/logo.png";

const Title = () => {
  return <img alt="logo" src={logo} className="h-full" data-testid="logo"/>;
};

//default export
export default Title;
